//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SectionTemplate from './SectionTemplate.vue';
export default {
  extends: SectionTemplate,
  computed: {
    styleObject() {
      return {
        backgroundColor: this.data.background
      };
    }
  }
}
